export const getCurrentTime = (date?: string): string => {
  const currentDate = date ? new Date(date) : new Date();
  return [
    currentDate.getHours().toString().padStart(2, '0'),
    currentDate.getMinutes().toString().padStart(2, '0'),
  ].join(':');
};
